import { Link } from 'react-router-dom';
import { LegalLayout, Lead, Section, P, Bullets } from '../legal/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout title="Terms of use" updated="29 August 2026">
      <Lead>
        These terms cover your Mātou account and the community services it opens
        — such as your cloud storage and the other tools the collective hosts.
        By creating an account, you agree to them. We have kept them short and
        plain.
      </Lead>

      <Section title="Who we are">
        <P>
          Mātou Collective is an Indigenous-led collective building open-source
          digital infrastructure for community self-determination. These
          services are run by and for that community.
        </P>
      </Section>

      <Section title="Your account">
        <Bullets
          items={[
            'Keep your sign-in details secure, and do not share your account.',
            'Give accurate information when you register.',
            'You are responsible for what is done through your account.',
          ]}
        />
      </Section>

      <Section title="Using the services well">
        <P>These services are a shared space. Please:</P>
        <Bullets
          items={[
            'Follow the law, and respect the rights and dignity of others.',
            'Do not damage, overload, or try to break into the infrastructure.',
            "Do not upload other people's data without their consent.",
            'Do not use the services to harm, harass, or exploit anyone.',
          ]}
        />
      </Section>

      <Section title="Your data">
        <P>
          What you store stays yours. How we look after it is set out in our{' '}
          <Link
            to="/privacy"
            className="text-matou-teal-deep underline hover:text-matou-teal-medium"
          >
            Privacy policy
          </Link>
          .
        </P>
      </Section>

      <Section title="The Matou app">
        <P>
          If you use the Matou app, a few extra things apply:
        </P>
        <Bullets
          items={[
            'The app creates a recovery phrase on your device. It is yours alone to back up and protect — if it is lost, neither we nor your community can recover the identity it controls. Never share it; we will never ask for it.',
            'Membership of a community is granted by that community’s administrators under its own rules, and what you post there — chat, notices, contributions — must meet the same standards as any shared space above. Communities are administrator-moderated.',
            'Records of community decisions — votes, approvals, sign-offs — are cryptographically signed and shared with other members, and are intended to be durable once made.',
            'The app is for adults, eighteen and over. Our child safety standards apply to all app content.',
          ]}
        />
        <P>
          The app&apos;s software is open source under the AGPL-3.0 licence,
          which governs your rights to use, modify and share it.
        </P>
      </Section>

      <Section title="Availability">
        <P>
          The collective runs this infrastructure with care, but on a community
          scale and often on modest hardware. We cannot promise it will never go
          down. When something breaks, we aim to be honest and quick about it,
          and to protect your data throughout.
        </P>
      </Section>

      <Section title="Ending your account">
        <P>
          You can close your account and leave at any time. We may suspend or
          remove an account that puts the community, other people, or the
          infrastructure at risk. When we do, we will act fairly and, wherever
          we can, explain why.
        </P>
      </Section>

      <Section title="Changes">
        <P>
          We may update these terms. We will update the date above and tell you
          about significant changes.
        </P>
      </Section>

      <Section title="Contact">
        <P>
          Questions about these terms are welcome at{' '}
          <a
            href="mailto:info@matou.nz"
            className="text-matou-teal-deep underline hover:text-matou-teal-medium"
          >
            info@matou.nz
          </a>
          .
        </P>
      </Section>
    </LegalLayout>
  );
}
